import { Injectable } from "@angular/core";

import { AsyncDependencyBoth } from "../base-classes/async-dependency-both";
import { Institution } from "../models/institution/institution.interface";

import { BackendCallService } from "./backend-call.service";

@Injectable({
  providedIn: "root",
})
export class InstitutionService extends AsyncDependencyBoth {
  private institution: Institution;

  constructor(private backend: BackendCallService) {
    super();
    this.init(backend);
  }

  protected onReady(): void {
    this.api_get_institution()
      .then((institution) => (this.institution = institution))
      .catch(() => (this.institution = {} as Institution))
      .finally(() => this.set_ready());
  }

  public get_institution(): Institution {
    return this.institution;
  }

  /**
   * holt sich alle Einstellungen aus Feripro
   * used by home page, data-protection page & impressum
   * @returns ionsitution settings object
   */
  private api_get_institution(): Promise<Institution> {
    const url = `${this.backend.get_feripro_backend_domain()}/api/institution`;
    return this.backend.get<Institution>(url);
  }
}
